import vueComponentOptions from 'components/InputColor.vue';

const TextInput = Vue.extend(vueComponentOptions);

module.exports = TextInput;
